import { render } from "./ListaSinistrosView.vue?vue&type=template&id=205e08a5&scoped=true"
import script from "./ListaSinistrosView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosView.vue?vue&type=script&lang=js"

import "./ListaSinistrosView.vue?vue&type=style&index=0&id=205e08a5&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205e08a5"]])

export default __exports__